export enum SetPasswordError {
  InvalidInvitationToken = 'InvalidInvitationToken',
  InvalidUserInvitationToken = 'InvalidUserInvitationToken',
  PasswordMinimumRequiredLength = 'PasswordMinimumRequiredLength',
}
